import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CategoryDTO  {
    _originalTypeClassName = "ekylikeio.BO.CategoryDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CategoryDTO.translate = translateService;
}
this.InternalId = null;
this.Id = null;
this.Name = null;
this.Date = null;
this.Line2 = null;
this.Count = 0;
this.Available = false;
this._key = this.InternalId = 0; 
}

static translate: TranslateService;
_key: any;
private _InternalId:any;
get InternalId(): any {
    return this._InternalId;
  }
set InternalId(value: any) {
    this._InternalId = value;
    this._key = value;
  }
Id:any;
Name:any;
Date:any;
Line2:any;
Count:any;
Available:any;

static AllStudents(parent: any): any{let students = [];
if (parent == null) {return students;}
for (let _is = 0; _is < (parent?.parentToStudent?.linq?.where((s) => s?.IsDeleted != true)?.toArray() == null ? 0 : parent?.parentToStudent?.linq?.where((s) => s?.IsDeleted != true)?.toArray().length); _is++) {let s = parent?.parentToStudent?.linq?.where((s) => s?.IsDeleted != true)?.toArray()[_is];let student = new Domain.CategoryDTO();student.Id = s?.Id;student.Name = s?.FullName;student.Line2 = Domain.SchoolClass.GetFullName(s?.SchoolClass);students?.add(student);}
return students?.linq?.orderBy((s) => s?.Name)?.toArray();
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.InternalId == null || $this.InternalId == 0;
            }


}